export default {
    path: '/entBackstage',
    redirect: '/entBackstage/formTemplate/list',
    meta: {
        title: "企业后台",
        icno: ""
    },
    children: [{
        path: 'formTemplate/list',
        name: 'FormTemplateHome',
        component: () => import("@/views/entBackstage/formTemplate/list/index.vue")
    }, {
        path: 'formTemplate/create',
        name: 'FormTemplateCreate',
        component: () => import("@/views/entBackstage/formTemplate/create/index.vue")
    }]
}